import styles from './KpiCard.module.css';

interface KpiCardProps {
  label: string;
  value: string;
  delta: string;
  trend: 'up' | 'down' | 'flat';
  onClick?: () => void;
  linkLabel?: string;
}

export function KpiCard({ label, value, delta, trend, onClick, linkLabel }: KpiCardProps) {
  const clickable = typeof onClick === 'function';
  return (
    <div
      className={`${styles.kpi} ${clickable ? styles.clickable : ''}`}
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick?.(); } } : undefined}
    >
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
      <div className={`${styles.delta} ${styles[trend]}`}>{delta}</div>
      {clickable && linkLabel && <div className={styles.link}>{linkLabel}</div>}
    </div>
  );
}
